import { getLocaleHeader } from "@lib/util/get-locale-header"
import Medusa, { FetchArgs, FetchInput } from "@medusajs/js-sdk"
import { resolveMedusaBackendUrl } from "@lib/util/medusa-backend-url"
import { resolveStagedPreviewBackendUrl } from "@lib/util/staged-preview"

const MEDUSA_BACKEND_URL = resolveMedusaBackendUrl({
  isServer: typeof window === "undefined",
  internalUrl: process.env.MEDUSA_BACKEND_INTERNAL_URL,
  publicUrl: resolveStagedPreviewBackendUrl(process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL),
})

export const sdk = new Medusa({
  baseUrl: MEDUSA_BACKEND_URL,
  debug: process.env.NODE_ENV === "development",
  publishableKey: process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
})

const originalFetch = sdk.client.fetch.bind(sdk.client)

sdk.client.fetch = async <T>(
  input: FetchInput,
  init?: FetchArgs
): Promise<T> => {
  const headers = init?.headers ?? {}
  let localeHeader: Record<string, string | null> | undefined
  try {
    localeHeader = await getLocaleHeader()
    headers["x-medusa-locale"] ??= localeHeader["x-medusa-locale"]
  } catch {}

  const newHeaders = {
    ...localeHeader,
    ...headers,
  }
  init = {
    ...init,
    headers: newHeaders,
  }
  return originalFetch(input, init)
}
